import { Component, effect, input, signal, untracked } from '@angular/core';
import { CustomFieldCollectionDetailDto, CustomFieldCollectionMemberMergeDto } from '@artemis-software/wr-api';
import { createForm } from '@sonofabit/ng-core';
import { Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-custom-field-collection-form',
  templateUrl: './custom-field-collection-form.component.html',
  styleUrls: ['./custom-field-collection-form.component.scss'],
})
export class CustomFieldCollectionFormComponent {
  readonly folderPath = input('');
  readonly customFieldCollection = input<CustomFieldCollectionDetailDto | null>(null);

  form = this.createFormFromDetail(null);
  canEdit = signal(false);

  constructor() {
    // Replaces the former @Input() setter. folderPath is read untracked so it keeps seeding the
    // category of a NEW collection only — a later folder change must not rebuild a filled form.
    effect(() => {
      const detail = this.customFieldCollection();
      this.form = untracked(() => this.createFormFromDetail(detail));
    });
  }

  createFormFromDetail(detail: CustomFieldCollectionDetailDto | null) {
    if (detail) {
      this.canEdit.set(!!detail?.permissions.canEdit);
    }
    return createForm(({ field }) => {
      return {
        id: field({ value: detail?.id }),
        title: field({ value: detail?.title, validators: [Validators.required] }),
        description: field({ value: detail?.description }),
        color: field({ value: detail?.color }),
        category: field({ value: detail?.category ?? this.folderPath() }),
        fields: field({
          value: (detail?.members ?? []).map(member => ({
            id: member.id,
            fieldId: member.field.id,
            required: member.required ?? false,
            colSpan: member.colSpan ?? 12,
            visibleIfFieldId: member.visibleIfFieldId,
            visibleIfValue: member.visibleIfValue,
          } as CustomFieldCollectionMemberMergeDto)),
        }),
      };
    });
  }
}
